module.exports = __webpack_public_path__ + "static/img/img-main-features-setcion-2@3x.162a195.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/img-main-features-setcion-2@3x.png
// module id = xVXh
// module chunks = 18